"use client";

import { Box, styled } from "@mui/material";

const Section = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    "&:nth-child(odd)": {
      backgroundColor: "grey.100",
    },
  })
);

export default Section;